import { LayaGL } from "../../../layagl/LayaGL";
import { Pool } from "../../../utils/Pool";
import { Command2D } from "./Command2D";
export class Set2DShaderDataCMD extends Command2D {
    static create(shaderData, nameID, value, shaderDataType) {
        let cmd = Set2DShaderDataCMD._pool.take();
        cmd.setDest(shaderData);
        cmd._setRenderDataCMD.propertyID = nameID;
        cmd._setRenderDataCMD.dataType = shaderDataType;
        cmd._setRenderDataCMD.value = value;
        return cmd;
    }
    constructor() {
        super();
        this._globalMode = false;
        this._setRenderDataCMD = LayaGL.render2DRenderPassFactory.createSetRenderDataCMD();
    }
    getRenderCMD() {
        return this._setRenderDataCMD;
    }
    setDest(value) {
        this._setRenderDataCMD.dest = value;
    }
    recover() {
        Set2DShaderDataCMD._pool.recover(this);
        this._globalMode = false;
    }
}
Set2DShaderDataCMD._pool = Pool.createPool(Set2DShaderDataCMD);
export class Set2DDefineCMD extends Command2D {
    static create(shaderData, define, addDefine) {
        let cmd = Set2DDefineCMD._pool.take();
        cmd.setDest(shaderData);
        cmd._setRenderDefineCMD.add = addDefine;
        cmd._setRenderDefineCMD.define = define;
        return cmd;
    }
    constructor() {
        super();
        this._globalMode = false;
        this._setRenderDefineCMD = LayaGL.render2DRenderPassFactory.createSetShaderDefineCMD();
    }
    setDest(value) {
        this._setRenderDefineCMD.dest = value;
    }
    getRenderCMD() {
        return this._setRenderDefineCMD;
    }
    recover() {
        Set2DDefineCMD._pool.recover(this);
        this._globalMode = false;
    }
}
Set2DDefineCMD._pool = Pool.createPool(Set2DDefineCMD);
